// extracted by mini-css-extract-plugin
export var columnList = "_ao-0";